import { LeftArrow } from '../icons'
import { useDispatch } from 'react-redux'
import { setWidgetSizeWideOpen, setWidgetTab } from 'app/redux/widget/widget.actions'
import { setSelectedQuestion } from 'app/redux/messages/messages.actions'
import ClamedText from '../ClampedText'
import './questionItem.scss'

const QuestionItem = ({ question }) => {
  const dispatch = useDispatch()

  const handleShowQuestionDetail = () => {
    dispatch(setWidgetSizeWideOpen(true))
    dispatch(setSelectedQuestion(question))
    dispatch(setWidgetTab(2))
  }

  return (
    <div className="question_item_wrapper">
      <div onClick={handleShowQuestionDetail} className="question_item">
        <div className="question_item_content">
          <ClamedText className="question_item_title" text={question.question} linesNum={2} maxChar={105} />
        </div>
        <div className="question_item_arrow">
          <LeftArrow />
        </div>
      </div>
    </div>
  )
}

export default QuestionItem
